import { render, staticRenderFns } from "./deptuser.vue?vue&type=template&id=77b39450&scoped=true"
import script from "./deptuser.vue?vue&type=script&lang=js"
export * from "./deptuser.vue?vue&type=script&lang=js"
import style0 from "./deptuser.vue?vue&type=style&index=0&id=77b39450&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b39450",
  null
  
)

export default component.exports